
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignArrowForeward as ObiSignArrowForewardElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-arrow-foreward.js';
 
 
 

 
 export const ObiSignArrowForeward = createComponent({
   react: React,
   tagName: 'obi-sign-arrow-foreward',
   elementClass: ObiSignArrowForewardElement,
   events: {
     
   }
  });
 
 